import { Grid } from "antd";

import type { ScreenSize } from "design-system/types";

const { useBreakpoint } = Grid;

/**
 * @description: Gets true single screen size, as more than 1 key from useBreakpoint can be active when resizing screens.
 */
export const useScreenSize = (): ScreenSize => {
  const screens = useBreakpoint();

  const spanning = Object.entries(screens)
    .filter(screen => !!screen[1])
    .map(screen => ({
      [screen[0]]: true,
    }))
    .reverse()[0];

  if (Object.keys(spanning || {})?.length) {
    const k = Object.keys(spanning)[0];
    return k as ScreenSize;
  }

  return "xs";
};
